import { onUnmounted, ref } from 'vue';
import Lottie from 'lottie-web';
export function useLottie(containerRef, options) {
    const animationInstance = ref(null);
    const loadAnimation = () => {
        destroyAnimation();
        if (!containerRef.value) {
            console.error('[useLottie] Lottie container element is not available or null.');
            return;
        }
        if (!options.animationData) {
            console.error('[useLottie] Lottie animationData is not provided.');
            return;
        }
        const config = {
            renderer: 'svg',
            loop: options.loop ?? true,
            autoplay: options.autoplay ?? true,
            container: containerRef.value,
            animationData: options.animationData,
            ...(options.name && { name: options.name }),
        };
        animationInstance.value = Lottie.loadAnimation(config);
    };
    const pauseAtFrameAndResume = (pauseAtFrame, pauseDurationMs) => {
        if (!animationInstance.value)
            return;
        animationInstance.value.addEventListener('enterFrame', () => {
            const currentFrame = Math.ceil(animationInstance.value.currentFrame);
            if (currentFrame === pauseAtFrame) {
                animationInstance.value.pause();
                setTimeout(() => {
                    if (!animationInstance.value)
                        return;
                    animationInstance.value.play();
                }, pauseDurationMs);
            }
        });
    };
    const destroyAnimation = () => {
        if (animationInstance.value) {
            animationInstance.value.removeEventListener('enterFrame');
            animationInstance.value.destroy(options.name);
            animationInstance.value = null;
        }
    };
    onUnmounted(() => {
        destroyAnimation();
    });
    return {
        animationInstance,
        loadAnimation,
        destroyAnimation,
        pauseAtFrameAndResume,
    };
}
